/**
 * EPR – EPR settings
 */

const eprSettingsLocale = {
  eprSettings: {
    regNum: "Registration number",
    typeOfReg: "Type of registration",
    sysOperator: "System operator",
    regDate: "Registration date",
    status: "Status",
    licPaid: "License paid",
    licPaidFrom: "License paid from",
    licPaidTill: "License paid till",
    addTransToSee: "Add transactions to see data",
    addTrans: "Add transactions",
    addNewEPR: "Add new EPR",
    serverError: "Server error",
    ecoOrganisation: "Eco-organisation",
    taxNumber: "Tax number",
    columnPeriodicity: "Periodicity",
    columnFirstPeriodDue: "First period due",
  },
};

export default eprSettingsLocale;
